import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const getHeroTextLines = () => {
  if (typeof window !== 'undefined' && window.innerWidth <= 600) {
    // Mobile: 3 lines
    return [
      ["a", "creative", "designer"],
      ["who", "solve", "problems"],
      ["through", "designs"]
    ];
  }
  // Desktop: 3 lines (default)
  return [
    ["a", "creative", "designer"],
    ["who", "solve", "problems"],
    ["through", "designs"]
  ];
};

const BlurText = ({ text, className = "", duration = 1200, delay = 0 }) => {
  const [visibleWords, setVisibleWords] = useState(0);
  const [heroTextLines, setHeroTextLines] = useState(getHeroTextLines());

  useEffect(() => {
    const handleResize = () => {
      setHeroTextLines(getHeroTextLines());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const totalWords = heroTextLines.flat().length;

  useEffect(() => {
    const timer = setTimeout(() => {
      const interval = setInterval(() => {
        setVisibleWords(prev => {
          if (prev < totalWords) {
            return prev + 1;
          }
          clearInterval(interval);
          return prev;
        });
      }, 150);
      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(timer);
  }, [totalWords, delay]);

  return (
    <div className={`${className} hero-blur-text-container`} style={{ textTransform: 'capitalize', fontWeight: '700', fontSize: '5rem', lineHeight: '1.0' }}>
      {heroTextLines.map((line, lineIndex) => (
        <div key={lineIndex} style={{ marginBottom: '-0.5rem' }}>
          {line.map((word, wordIndex) => {
            const globalIndex = heroTextLines.slice(0, lineIndex).flat().length + wordIndex;
            // Add special class for 'creative' to control z-index
            const isCreative = word === 'creative';
            return (
              <span 
                key={globalIndex}
                className={isCreative ? 'creative-zfix' : ''}
                style={{
                  display: 'inline-block',
                  marginRight: '0.5rem',
                  filter: globalIndex < visibleWords ? 'blur(0px)' : 'blur(8px)',
                  opacity: globalIndex < visibleWords ? 1 : 0.3,
                  transform: globalIndex < visibleWords ? 'translateY(0)' : 'translateY(10px)',
                  transition: 'all 0.6s ease-out',
                  position: word === 'designer' || isCreative ? 'relative' : 'static',
                  zIndex: isCreative ? 3 : (word === 'designer' ? 2 : 1)
                }}
              >
                {word === 'designer' ? (
                  <b style={{ position: 'relative', zIndex: 2 }}>
                    {word}
                    <i className="shape" style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -55%)', // moved more to the left
                      width: '130%',
                      height: 'auto',
                      zIndex: 1 // Lower than .creative-zfix
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 342 109" fill="none" style={{ width: '100%', height: 'auto' }}>
                        <path
                          d="M253.155 4.12319C179.456 0.617146 91.2846 11.4859 35.3131 37.48C23.738 43.1662 13.2074 50.0672 9.48518 58.2225C7.11129 63.4544 8.36945 69.0739 12.7944 73.9157C24.7588 86.5424 53.2027 92.7743 77.8531 96.7297C130.264 104.404 189.093 105.9 242.022 98.8186C278.128 94.0163 333.81 80.7476 331.702 57.9287C330.278 40.312 300.158 28.947 271.116 22.8287C229.929 14.2389 184.868 11.2094 140.69 10.9254C118.641 10.9032 96.6353 12.9723 75.9683 16.9622C55.7475 20.967 35.3843 26.5841 21.0603 35.1764C18.6721 36.6381 14.3469 34.9147 16.6306 33.3123C34.5154 22.0658 63.249 14.7895 89.7558 10.7081C128.289 4.79971 169.262 6.5478 208.502 9.42424C263.111 13.8093 345.267 26.7545 340.899 62.4223C338.739 73.496 323.987 82.6389 307.218 88.9424C260.443 105.957 198.147 109.924 142.451 107.527C108.41 105.915 73.9979 102.68 43.2466 94.52C18.9855 88.0486 -1.71957 77.0983 0.113075 61.9359C3.55996 39.9836 52.3861 23.6213 87.5338 15.3129C118.603 8.007 151.942 3.39235 185.77 1.35539C208.317 0.00729162 231.163 -0.108754 253.744 1.17515C255.306 1.26404 256.436 1.99487 256.265 2.80966C256.099 3.61704 254.708 4.2022 253.155 4.12319Z"
                          fill="url(#paint0_linear_64_849)" />
                        <defs>
                          <linearGradient id="paint0_linear_64_849" x1="318.823" y1="54.22"
                            x2="16.3119" y2="54.22" gradientUnits="userSpaceOnUse">
                            <stop offset="0" stopColor="#F2CD8C" />
                            <stop offset="1" stopColor="#CC9260" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </i>
                  </b>
                ) : (
                  word
                )}
              </span>
            );
          })}
        </div>
      ))}
    </div>
  );
};

BlurText.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  duration: PropTypes.number,
  delay: PropTypes.number,
};

export default BlurText; 